// Work out the lower/upper bounds for a number input.
// Product add-on fields (WooCommerce Product Add-Ons) carry no min/max attributes;
// their limits live in data-restrictions and an optional add-on can go to 0
// (BRU-1082). Everything else keeps the quantity default of 1.
function getNumberInputBounds(input) {
  let min = 1;
  let max = Infinity;

  if (input.classList.contains('wc-pao-addon-field')) {
    min = 0;
    try {
      const restrictions = JSON.parse(input.dataset.restrictions || '{}');
      if (parseInt(restrictions.min) > 0) min = parseInt(restrictions.min);
      if (parseInt(restrictions.max) > 0) max = parseInt(restrictions.max);
    } catch (e) {}
  }

  if (input.hasAttribute('min') && input.min !== '') min = parseInt(input.min);
  const maxAttr = input.getAttribute('max');
  if (maxAttr && maxAttr !== '' && maxAttr !== 'Infinity') max = parseInt(maxAttr);

  return { min, max };
}

// Define the enhanceNumberInput function in the global scope
function enhanceNumberInput(input) {
  // Check if input is already in quantity-controls or quantity-wrapper
  const isInControls = input.parentElement.classList.contains('quantity-controls') || input.parentElement.classList.contains('quantity-wrapper');

  let controls, minusButton, plusButton;

  if (isInControls) {
    // Use existing controls structure
    controls = input.parentElement;
    minusButton = controls.querySelector('.quantity-btn.minus');
    plusButton = controls.querySelector('.quantity-btn.plus');

    // Skip if buttons already have event listeners (check for a marker)
    if (controls.classList.contains('enhanced')) return;
  } else {
    // Create controls wrapper
    controls = document.createElement('div');
    controls.className = 'quantity-controls';

    // Add disabled class if input is disabled
    if (input.disabled) {
      controls.classList.add('disabled');
    }

    // Create buttons
    minusButton = document.createElement('button');
    minusButton.type = 'button';
    minusButton.className = 'quantity-btn minus';
    minusButton.setAttribute('aria-label', 'Decrease value');

    plusButton = document.createElement('button');
    plusButton.type = 'button';
    plusButton.className = 'quantity-btn plus';
    plusButton.setAttribute('aria-label', 'Increase value');

    // Insert buttons and wrap input
    input.parentNode.insertBefore(controls, input);
    controls.appendChild(minusButton);
    controls.appendChild(input);
    controls.appendChild(plusButton);
  }

  // Mark as enhanced
  controls.classList.add('enhanced');

  // Add event listeners
  minusButton.addEventListener('click', () => {
    const currentValue = parseInt(input.value) || 0;
    const { min } = getNumberInputBounds(input);

    if (currentValue > min) {
      input.value = currentValue - 1;
      // Trigger both change and input events
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });

  plusButton.addEventListener('click', () => {
    const currentValue = parseInt(input.value) || 0;
    const { max } = getNumberInputBounds(input);

    if (currentValue < max) {
      input.value = currentValue + 1;
      // Trigger both change and input events
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  });

  // Validate manual input
  input.addEventListener('change', () => {
    const value = parseInt(input.value);
    const { min, max } = getNumberInputBounds(input);

    if (isNaN(value) || value < min) {
      input.value = min;
    } else if (max !== Infinity && value > max) {
      input.value = max;
    }
  });

  // Watch for disabled state changes
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === 'disabled') {
        controls.classList.toggle('disabled', input.disabled);
      }
    });
  });

  observer.observe(input, {
    attributes: true,
    attributeFilter: ['disabled']
  });
}

// Define the function to enhance all quantity inputs
function enhanceAllQuantityInputs() {
  // Keep track of processed inputs to avoid double processing
  const processedInputs = new Set();

  // Enhance WooCommerce quantity inputs
  document.querySelectorAll('.quantity').forEach(quantityDiv => {
    const input = quantityDiv.querySelector('.qty');
    if (input && !processedInputs.has(input)) {
      processedInputs.add(input);
      enhanceNumberInput(input);
    }
  });

  // Enhance quantity-wrapper inputs (for WooCommerce generated wrappers)
  document.querySelectorAll('.quantity-wrapper').forEach(wrapperDiv => {
    const input = wrapperDiv.querySelector('.qty');
    if (input && !processedInputs.has(input)) {
      processedInputs.add(input);
      enhanceNumberInput(input);
    }
  });

  // Enhance quantity-controls inputs (for multi-shipping) that aren't already processed
  document.querySelectorAll('.quantity-controls').forEach(controlsDiv => {
    const input = controlsDiv.querySelector('.qty');
    if (input && !processedInputs.has(input)) {
      processedInputs.add(input);
      enhanceNumberInput(input);
    }
  });

  // Enhance standalone number inputs (excluding those already processed or in .quantity/.quantity-controls divs)
  document.querySelectorAll('input[type="number"]:not(.qty)').forEach(input => {
    if (!processedInputs.has(input)) {
      processedInputs.add(input);
      enhanceNumberInput(input);
    }
  });
}

// Wait for DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
  // Initialize on page load
  enhanceAllQuantityInputs();
  
  // Set up WooCommerce Ajax event listeners using jQuery
  jQuery(function($) {
    // Listen for cart updates
    $(document.body).on('updated_cart_totals updated_wc_div wc_fragments_loaded wc_fragments_refreshed', function() {
      enhanceAllQuantityInputs();
    });
  });
  
  // Set up Gravity Forms event listeners
  jQuery(document).on('gform_post_render', function(event, formId, currentPage) {
    // Re-enhance inputs after form validation fails and form is re-rendered
    enhanceAllQuantityInputs();
  });
});